import React, { useEffect, useState } from 'react';
import {
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormHelperText,
    Box
} from '@mui/material';

const RadioGroupComp = ({
    value = '',
    error = '',
    disabled = false,
    onChange = null,
    onError = null,
    options = [],
    name = 'radio-group',
    label = '',
    required = false,
    className = '',
    row = false,
    size = 'medium',
    color = 'primary'
}) => {
    const [inputValue, setInputValue] = useState(value);

    const validate = () => {
        let validationError = null;

        if (required && inputValue === '') {
            validationError = 'Please select an option';
        }

        if (onError) {
            onError(validationError);
        }
        return !validationError;
    };

    const handleChange = (event) => {
        if (disabled) return;

        const selectedValue = event.target.value;
        setInputValue(selectedValue);

        if (onChange) {
            onChange(selectedValue);
        }

        // Clear error when user makes a selection
        if (onError && selectedValue !== '') {
            onError(null);
        }
    };

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    // Validate on blur or when required
    useEffect(() => {
        if (required) {
            validate();
        }
    }, [inputValue, required]);

    return (
        <Box className={className}>
            <FormControl
                component="fieldset"
                error={Boolean(error)}
                disabled={disabled}
                required={required}
                fullWidth
            >
                {label && (
                    <FormLabel
                        component="legend"
                        sx={{
                            marginBottom: 1,
                            '&.Mui-focused': {
                                color: `black`
                            }
                        }}
                    >
                        {label}
                    </FormLabel>
                )}

                <RadioGroup
                    name={name}
                    value={inputValue}
                    onChange={handleChange}
                    row={row}
                >
                    {options.map((option, index) => {
                        const optionValue = typeof option === 'string' ? option : option.value;
                        const optionLabel = typeof option === 'string' ? option : option.name;
                        const optionDisabled = typeof option === 'object' ? option.disabled : false;

                        return (
                            <FormControlLabel
                                key={index}
                                value={optionValue}
                                control={
                                    <Radio
                                        size={size}
                                        sx={{
                                            color: 'black',
                                            '&.Mui-checked': {
                                                color: 'black'
                                            },
                                            '&.Mui-disabled': {
                                                color: 'action.disabled'
                                            }
                                        }}
                                    />
                                }
                                label={optionLabel}
                                disabled={disabled || optionDisabled}
                                sx={{
                                    margin: 0,
                                    width: '100%',
                                    height:"24px",
                                    padding: 0.2,
                                    borderRadius: 1,
                                    color: 'black',
                                    '&:hover .MuiFormControlLabel-label, &:focus-within .MuiFormControlLabel-label': {
                                        fontWeight: 'bold'
                                    },
                                    '&.Mui-disabled': {
                                        opacity: 0.6
                                    },
                                    '& .MuiFormControlLabel-label': {
                                        fontSize: size === 'small' ? '0.875rem' : '1rem'
                                    }
                                }}
                            />
                        );
                    })}
                </RadioGroup>

                {error && (
                    <FormHelperText
                        error
                        sx={{
                            marginTop: 0.5,
                            marginLeft: 0
                        }}
                    >
                        {error}
                    </FormHelperText>
                )}
            </FormControl>
        </Box>
    );
};

export default RadioGroupComp;